import React from 'react';
import Form from '../../components/common/Form';
// import Joi from 'joi-browser';
import InviteAdminsTeamModal from './InviteAdminsFeedModal';

class TeamModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                team_name: props.team_name || ""
            },
            errors: {},
            accept: false
        };
    }

    // schema = {
    //     team_name: Joi.string().required().label("Team Name")
    // };

    doSubmit = (e) => {
        //const data = this.state.data;
        //this.props.acceptModal(e);
        this.setState({accept:true})
    };


    render() {
        let {visible_modal, onClickAway, acceptModal} = this.props;
        let {accept} = this.state;

        if(accept)
        {
            return (

              <div>
                  {/*<InviteAdminsTeamModal visible_modal={visible_modal}*/}
                  {/*                       onClickAway={onClickAway}*/}
                  {/*                       acceptModal={acceptModal}*/}
                  {/*                       team_name={this.state.data.team_name}*/}
                  {/*                       textTopMsg="You have Created a new team:"*/}
                  {/*                       grantPrivilegesMsg="Grant full admin privileges for all projects of this team"/>*/}
              </div>
            )
        }
        return (

            <div id="teamModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                {/*<div className="modal-content">*/}
                {/*    <h1 className="text-bold m-m-b">Add New Team</h1>*/}
                {/*    <div className="separator"></div>*/}
                {/*    <p className="m-m-b">Name your team</p>*/}
                {/*    <div className="form-group m-m-b">*/}
                {/*        {this.renderInput("team_name", "Team Name", '','',true)}*/}
                {/*    </div>*/}
                {/*    <div className="separator m-m-b"></div>*/}
                {/*    <div className="submit-buttons row">*/}
                {/*        <div className="col-md-6">*/}
                {/*            <button disabled={false}*/}
                {/*                    onClick={onClickAway}*/}
                {/*                    name="cancel_team"*/}
                {/*                    id="cancel_team"*/}
                {/*                    type="button"*/}
                {/*                    className='btn-white btn-xs text-bold'>Cancel</button>*/}
                {/*        </div>*/}
                {/*        <div className="col-md-6 text-right save-submit">*/}
                {/*            {this.renderButton("Add", "change_team", 'finish_team_btn','btn btn-action btn-lg m-xl-b',false)}*/}

                {/*            <button disabled={false}*/}
                {/*                    name="change_team"*/}
                {/*                    id="finish_team_btn"*/}
                {/*                    type="button"*/}
                {/*                    onClick={this.doSubmit}*/}
                {/*                    className='btn-action btn-lg m-xl-b'>Add</button>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*</div>*/}
            </div>
        )
    }
}

export default TeamModal;